import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchPagesByUser, fetchAuthor } from '../../actions';
import BookLink from '../book-components/book-link';
import { mmddyyyy } from '../date';

function ShowProfile(props) {
  useEffect(() => {
    // const onMyProfile = matchPath(props.location.pathname, {
    //   path: '*/myprofile*',
    // });
    if (props.current) {
      props.fetchAuthor();
      props.fetchPagesByUser(props.current.id);
    } else {
      props.fetchPagesByUser(props.match.params.userID);
    }
    // }
    // }
  }, [props.current]);

  const showEduc = () => {
    if (props.current.education) {
      return (
        <p>
          <i className="fas fa-graduation-cap badge" alt="Education" />{props.current.education}
        </p>
      );
    }
    return <></>;
  };

  const showLoc = () => {
    if (props.current.location) {
      return (
        <p>
          <i className="fas fa-map-marker-alt badge" alt="Location" />{props.current.location}
        </p>
      );
    }
    return <></>;
  };

  const showPronouns = () => {
    if (props.current.pronouns) {
      return (
        <p>
          <i className="fas fa-transgender-alt badge" />{props.current.pronouns}
        </p>
      );
    }
    return <></>;
  };

  const showJoinedOn = () => {
    if (props.current.createdAt) {
      return (
        <p>
          <i id="joined-on">Joined on  </i>
          {mmddyyyy(props.current.createdAt)}
        </p>
      );
    }
    return <></>;
  };

  const showStats = () => {
    if (props.current.pronouns || props.current.education || props.current.location) {
      return (
        <div className="profile-bio">
          {showLoc()}
          {showEduc()}
          {showPronouns()}
        </div>
      );
    }
    return <></>;
  };

  const showStories = () => {
    if (props.userPages.length === 0) {
      return <p>None yet!</p>;
    }
    return (
      <div className="profile-stories">
        {props.userPages.map((story) => {
          return (
            <div key={story.id} className="profile-story-listing">
              <BookLink className="story-link" key={story.id} to={`/books/${story.Chapter?.Book?.id}/chapters/${story.Chapter.id}/pages/${story.id}`}>
                <p id="user-story-title">{story.title}</p>
              </BookLink>
              <p id="user-story-book">{story.Chapter?.Book?.title}</p>
              <p id="user-story-chapter">chapter: <span id="italic"> {story.Chapter?.title}</span></p>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="profile-bar">
        <img className="profile-pic" alt="" src={props.current.profpic} />
        <div className="profile-details">
          <div className="profile-name-bar">
            <h1 className="profile-name">{props.current.name}</h1>
            <p className="profile-username">@{props.current.username}</p>
          </div>
          {showStats()}
          {showJoinedOn()}
        </div>
      </div>
      <div id="profile-line" />
      <div className="profile-body">
        <div className="profile-stories">
          <h2>Stories</h2>
          {showStories()}
        </div>
        <div className="profile-description">
          <h3>About</h3>
          <p className="description">{props.current.description || 'This user hasn\'t added a bio yet!'}</p>
        </div>
      </div>

    </>
  );
}

const mapStateToProps = (state) => (
  {
    userPages: state.userPages.all,
    author: state.author.current,
  }
);

// export default ShowProfile;
export default withRouter(connect(mapStateToProps, { fetchPagesByUser, fetchAuthor })(ShowProfile));
